<template>
    <div class="card all-history">
        <div class="card__header">
            <div class="tabs">
				<button class="btn btn--white btn--xs tabs__btn" :class="[activeTab === 'results' ? 'active' : '']"
						@click="selectTab('results')">
					История игр
				</button>
				<button class="btn btn--white btn--xs tabs__btn" :class="[activeTab === 'wins' ? 'active' : '']"
						@click="selectTab('wins')">
					Большие выигрыши
				</button>
            </div>
        </div>
        <div class="table-wrap">
            <table class="table text-center">
                <thead>
                	<tr>
                	    <th>Игра</th>
                	    <th>Логин</th>
                	    <th>Ставка</th>
                	    <th>X</th>
                	    <th>Выигрыш</th>
                	</tr>
                </thead>
                <tbody>
                	<tr v-for="game in this.results" @click="showGame(game.id, game.game)" v-show="activeTab === 'results'">
                	    <td>
							<svg v-if="game.game === 'dice'" height="14" width="14"><use href="#svg-icon-dice"></use></svg>
							<svg v-if="game.game === 'mines'" height="14" width="14"><use href="#svg-icon-mines"></use></svg>
							<svg v-if="game.game === 'coin'" height="14" width="14"><use href="#svg-icon-contrast"></use></svg>
						</td>
                	    <td>{{ game.username }}</td>
                	    <td>{{ parseFloat(game.bet).toFixed(2) }}</td>
                	    <td v-if="game.game === 'dice'">{{ (100 / game.chance).toFixed(2) }}</td>
                	    <td v-else>{{ (game.chance).toFixed(2) }}</td>
                	    <td :class="[game.win > 0 ? 'text-success' : '']">{{parseFloat(game.win).toFixed(2) }}</td>
                	</tr>
                	<tr v-for="game in this.wins" @click="showGame(game.id, game.game)" v-show="activeTab === 'wins'">
                	    <td>
							<svg v-if="game.game === 'dice'" height="14" width="14"><use href="#svg-icon-dice"></use></svg>
							<svg v-if="game.game === 'mines'" height="14" width="14"><use href="#svg-icon-mines"></use></svg>
							<svg v-if="game.game === 'coin'" height="14" width="14"><use href="#svg-icon-contrast"></use></svg>
                	    </td>
                	    <td>{{ game.username }}</td>
                	    <td>{{ parseFloat(game.bet).toFixed(2) }}</td>
                	    <td v-if="game.game === 'dice'">{{ (100 / game.chance).toFixed(2) }}</td>
                	    <td v-else>{{ (game.chance).toFixed(2) }}</td>
                	    <td :class="[game.win > 0 ? 'text-success' : '']">{{parseFloat(game.win).toFixed(2) }}</td>
                	</tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
    export default {
        // props: ['myGames'],
        data() {
            return {
                activeTab: 'results',
                tableLength: 10,
                minWinAmount: 150,
                maxWinAmount: 100000,
                firstRun: true,
            }
        },
        computed: {
            results: {
                get: function() {
                    return this.$root.history.results;
                },
                set: function(games) {
                    this.$root.history.results = games;
                }
            },
            wins: {
                get: function() {
                    return this.$root.history.wins;
                },
                set: function(games) {
                    this.$root.history.wins = games;
                }
            },
            history: {
                set: function(game) {
                    if (this.$root.history.results.length >= this.tableLength) {
                        this.$root.history.results.pop();
                    }

                    this.$root.history.results.unshift(game);

                    if(game.win - game.bet >= this.minWinAmount && game.win - game.bet < this.maxWinAmount) {
                        if (this.$root.history.wins.length >= this.tableLength) {
                            this.$root.history.wins.pop();
                        }

                        this.$root.history.wins.unshift(game);
                    }
                },
                get: function() {
                    return this.$root.history;
                }
            }
        },
        methods: {
            fillTable() {
                if(this.firstRun) {
                    this.$socket.emit('gameHistory', (data) => {
                        this.results = data.games.length ? data.games : [];
                        this.wins = data.wins.length ? data.wins : [];

                        this.firstRun = false;
                    });
                }
            },
            showGame(id, game) {
                this.$root.emitter.emit('showGame', {
                    id: id, 
                    game: game
                });
            },
            selectTab(tab) {
                if (tab === this.activeTab) {
                    return;
                }

                this.activeTab = tab;
            }
        },
        sockets: {
            connect: function() {
                this.fillTable();
            },
            newGame(game) {
                this.history = game;
            }
        }
    }
</script>